// extracted by mini-css-extract-plugin
export default {"label":"label__YqBWb","dmLabel":"dmLabel__OcoLn","isChecked":"isChecked__0Fj6u","dmIsChecked":"dmIsChecked__ESD11"};